import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreditCard } from 'lucide-react';

export function PaymentSetupPage() {
  const [loading] = useState(false);
  const navigate = useNavigate();

  const handlePaymentLinkRedirect = () => {
    // Redirect to Stripe Payment Link for subscription setup
    window.open('https://buy.stripe.com/bJe3cv0RL1UXdGg000', '_blank');
    navigate('/journal');
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-600 via-indigo-600 to-blue-500 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-white border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 via-indigo-600 to-blue-500 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center mb-8">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-indigo-100 rounded-xl">
              <CreditCard className="h-8 w-8 text-indigo-600" />
            </div>
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Add Payment Method</h2>
          <p className="text-gray-600 mt-2">
            Set up your subscription to continue using VZMO
          </p>
        </div>

        <div className="space-y-4">
          <p className="text-gray-600 text-center">
            Click below to set up your subscription securely through Stripe
          </p>
          <button
            onClick={handlePaymentLinkRedirect}
            disabled={loading}
            className="w-full px-4 py-3 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 transition-colors"
          >
            {loading ? 'Processing...' : 'Set Up Subscription'}
          </button>
          <button
            onClick={() => navigate('/journal')}
            className="w-full px-4 py-2 text-gray-600 hover:text-gray-900 text-sm"
          >
            Skip for now
          </button>
        </div>
      </div>
    </div>
  );
}